export default __webpack_public_path__ + "media/images/valid-icon-f7bb36cd.svg";